import {Controller} from "stimulus"

// A keyboard- and screen-reader-friendly .popup-form: the trigger reports
// aria-expanded, opening moves focus to the initialFocus target, and closing
// (the Close link or Escape) hides the panel and returns focus to the trigger.
export default class extends Controller {
    static targets = ["trigger", "panel", "initialFocus"]

    // Turbo can restore a snapshot with the panel open, so read the state
    // rather than assume it is closed.
    connect() {
        this.triggerTarget.setAttribute("aria-expanded", String(this.isOpen()))
    }

    open(event) {
        event.preventDefault()
        this.panelTarget.classList.add("editing")
        this.triggerTarget.setAttribute("aria-expanded", "true")
        if (this.hasInitialFocusTarget) this.initialFocusTarget.focus()
    }

    close(event) {
        if (event) event.preventDefault()
        this.panelTarget.classList.remove("editing")
        this.triggerTarget.setAttribute("aria-expanded", "false")
        this.triggerTarget.focus()
    }

    closeOnEscape(event) {
        if (event.key !== "Escape" || !this.isOpen()) return

        this.close(event)
    }

    isOpen() {
        return this.panelTarget.classList.contains("editing")
    }
}
